module.exports = __webpack_public_path__ + "img/car.4f8b8bbb.svg";